// 人才培训路由白名单
import { talentTrainingWhite } from './talentTraining'
// 产业园路由白名单
import { industrialParkWhite } from './industrialPark'
// 关于我们白名单
import { aboutUsWhite } from "./aboutUs"
// 产教融合
import { fusionsWhite } from './fusion'

/**
 * 路由白名单
 */
let constRouters = [
	{
		path: '/home'
	},
	{
		path: '/register'
	},
	{
		path: '/findPassword'
	},
	// 平台协议
	{
		path: '/agreement'
	},
	// 资讯公告
	{
		path: '/infoNotice'
	},
	{
		path: '/infoNotice/detail'
	},
	// 预览
	{
		path: '/filePreview'
	},
	// 找工作
	{
		path: '/searchJob'
	},
	{
		path: '/searchJob/jobDetail'
	},
	{
		path: '/searchJob/firmDetail'
	},
	// 找人才
	{
		path: '/searchTalents'
	},
	// 招聘会
	{
		path: '/recruitmentFair'
	},
	{
		path: '/recruitmentFairDetail'
	},
	// 招考专栏
	{
		path: '/recruitmentColumn'
	},
	{
		path: '/recruitmentColumnDetails'
	},
	{
		path: '/recruitmentColumnEnroll'
	},
	{
		path: '/recruitmentColumnPostDetailsUiV'
	},
	// 人才服务
	{
		path: '/talentService'
	},
	{
		path: '/talentService/detail'
	},
	{
		path: '/talentService/activity'
	},
	{
		path: '/talentService/activityDetail'
	}
]

constRouters = [ ...constRouters, ...talentTrainingWhite, ...industrialParkWhite, ...aboutUsWhite, ...fusionsWhite ]

export default constRouters
